export default __webpack_public_path__ + "static/media/Shoulder Pad of the Cackling Marionette.a8d78726.jpg";